module.exports = __webpack_public_path__ + "static/media/01-subscribe.98d346c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/01-subscribe.png
// module id = 627
// module chunks = 1